// src/components/providers/external-items-operations-provider/external-items-operations-provider.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_ConnectExternalMailboxMutation($context: ContextInput!, $mailboxType: String!, $redirectUri: String!) {\n    connectExternalMailbox(context: $context, mailboxType: $mailboxType, redirectUri: $redirectUri) {\n      redirectUri {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment TripsUIToastUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment TripsUIToastFragment on TripsUIToast {\n    analytics {\n      linkName\n      referrerId\n    }\n    text\n    actionText\n    action {\n      ...TripsUIToastUILinkActionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_SaveExternalItemsToTripMutation(\n    $context: ContextInput!\n    $tripId: String!\n    $itemIdsToAdd: [String!]!\n    $itemIdsToRemove: [String!]!\n  ) {\n    saveExternalItemsToTrip(context: $context, tripId: $tripId, itemIdsToAdd: $itemIdsToAdd, itemIdsToRemove: $itemIdsToRemove) {\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_CreateTripMutation(\n    $context: ContextInput!\n    $name: String!\n    $description: String\n    $itemId: String\n    $operationType: String\n    $tripContext: TripsUITripContextInput\n  ) {\n    createTrip(context: $context, name: $name, description: $description, itemId: $itemId, operationType: $operationType, tripContext: $tripContext) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_DeleteTripMutation($context: ContextInput!, $tripId: String!) {\n    deleteTrip(context: $context, tripId: $tripId) {\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_EditTripMutation($context: ContextInput!, $description: String, $name: String, $tripId: String!) {\n    editTrip(context: $context, description: $description, name: $name, tripId: $tripId) {\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_UpdateTripItemTripMutation(\n    $context: ContextInput!\n    $tripContext: TripsUITripContextInput!\n    $itemId: String!\n    $operationType: String!\n  ) {\n    updateTripItemTrip(context: $context, tripContext: $tripContext, itemId: $itemId, operationType: $operationType) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_SendTripInviteMutation($tripId: String!, $recipients: String!, $message: String!, $context: ContextInput!) {\n    sendTripInvite(tripId: $tripId, recipients: $recipients, message: $message, context: $context) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_CreateTripItineraryTemplateMutation($tripId: String!, $context: ContextInput!) {\n    createTripItineraryTemplate(tripId: $tripId, context: $context) {\n      status\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_RemoveTripItemMutation($context: ContextInput!, $itemId: String!, $tripId: String!) {\n    removeTripItem(context: $context, itemId: $itemId, tripId: $tripId) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_SaveTripItemsMutation($context: ContextInput!, $tripId: String, $criteria: TripsUISaveTripItemsCriteriaInput!) {\n    saveTripItems(context: $context, tripId: $tripId, criteria: $criteria) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n      url {\n        value\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_UpdateTripItemDatesMutation($context: ContextInput!, $itemIds: [String!], $tripId: String!, $dateRange: DateRangeInput!) {\n    updateTripItemDates(context: $context, itemIds: $itemIds, tripId: $tripId, dateRange: $dateRange) {\n      status\n      toast {\n        ...TripsUIToastFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_UpdateTripItemVoteMutation($context: ContextInput!, $tripId: String!, $itemId: String!) {\n    updateTripItemVote(context: $context, tripId: $tripId, itemId: $itemId) {\n      ... on TripsUIUpdateTripItemVoteFailureResponse {\n        toast {\n          ...TripsUIToastFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  mutation SharedUIWeb_SaveTripItemCommentMutation(\n    $context: ContextInput!\n    $tripId: String!\n    $itemId: String!\n    $comment: String!\n    $commentId: String\n  ) {\n    saveTripItemComment(context: $context, tripId: $tripId, itemId: $itemId, comment: $comment, commentId: $commentId) {\n      ... on TripsUISaveTripItemCommentFailureResponse {\n        toast {\n          ...TripsUIToastFragment\n        }\n      }\n      ... on TripsUISaveTripItemCommentSuccessResponse {\n        actionCount {\n          count\n          accessibility\n        }\n        comments {\n          avatar {\n            ... on TripsUITextAvatar {\n              text\n            }\n          }\n          comment\n          id\n          name\n          timestamp\n        }\n        impressionAnalytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
import { useMutation } from "@apollo/client";
// src/components/providers/get-default-operation-state.ts
function getDefaultOperationsState(defaultTripOperationKeys) {
    return defaultTripOperationKeys.reduce(function(accum, next) {
        return Object.assign(accum, _define_property({}, next, {
            status: "UNKNOWN"
        }));
    }, {});
}
// src/components/providers/external-items-operations-provider/context/external-items-context.ts
import React from "react";
// src/components/providers/operations-provider-types.ts
var OperationFailureType = /* @__PURE__ */ function(OperationFailureType2) {
    OperationFailureType2["GRAPHQL"] = "GRAPHQL";
    OperationFailureType2["NO_PROVIDER"] = "NO_PROVIDER";
    OperationFailureType2["UNKNOWN"] = "UNKNOWN";
    return OperationFailureType2;
}(OperationFailureType || {});
// src/components/providers/external-items-operations-provider/context/get-default-operation.ts
function getDefaultOperation(operationName) {
    return function() {
        return Promise.resolve({
            success: false,
            failureReason: "No ExternalItemsOperationsProvider found in tree found while calling ".concat(operationName),
            failure: {
                type: "NO_PROVIDER" /* NO_PROVIDER */ 
            }
        });
    };
}
// src/components/providers/external-items-operations-provider/context/external-items-context.ts
var defaultExternalItemsOperationsContext = {
    connectExternalMailbox: getDefaultOperation("connectExternalMailbox"),
    saveExternalItemsToTrip: getDefaultOperation("saveExternalItemsToTrip")
};
var ExternalItemsOperationsContext = React.createContext(_object_spread_props(_object_spread({}, defaultExternalItemsOperationsContext), {
    state: getDefaultOperationsState(Object.keys(defaultExternalItemsOperationsContext))
}));
// src/components/providers/register-operation.ts
function registerOperation(params) {
    return function executeOperation(operation, updateState, variables) {
        updateState(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
                status: "IN_PROGRESS"
            }));
        });
        return operation({
            variables: variables
        }).then(function(response) {
            if (response.errors) {
                var error = {
                    failureReason: "".concat(params.operationName, " failed with graphql error(s)"),
                    failure: {
                        type: "GRAPHQL" /* GRAPHQL */ ,
                        errors: response.errors
                    }
                };
                updateState(function(prevState) {
                    return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
                        status: "FAILURE",
                        error: error
                    }));
                });
                return _object_spread({
                    success: false
                }, error);
            }
            if (!response.data) {
                return Promise.reject(new Error("".concat(params.operationName, " returned null data")));
            }
            updateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
                    status: "SUCCESS",
                    result: response
                }));
            });
            return _object_spread({
                success: true
            }, response);
        }).catch(function(error) {
            var failureReason = "unexpected error encountered while calling ".concat(params.operationName);
            var completeErrorMessage = "".concat(failureReason, ": ").concat(_instanceof(error, Error) ? error.message : error);
            var structuredError = {
                failureReason: failureReason,
                failure: {
                    type: "UNKNOWN" /* UNKNOWN */ ,
                    error: new Error(completeErrorMessage)
                }
            };
            updateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), _define_property({}, params.operationName, {
                    status: "FAILURE",
                    error: structuredError
                }));
            });
            return _object_spread({
                success: false
            }, structuredError);
        });
    };
}
// src/components/providers/external-items-operations-provider/operations/connect-external-mailbox/connect-external-mailbox.ts
var connectExternalMailbox = registerOperation({
    operationName: "connectExternalMailbox"
});
// src/components/providers/external-items-operations-provider/operations/connect-external-mailbox/mutation/connect-external-mailbox-mutation.ts
import { gql } from "@apollo/client";
var __ConnectExternalMailboxMutation = gql(_templateObject());
// src/components/providers/external-items-operations-provider/operations/save-external-items-to-trip/mutation/save-external-items-to-trip-mutation.ts
import { gql as gql3 } from "@apollo/client";
// src/components/providers/fragments/trips-ui-toast.ts
import { gql as gql2 } from "@apollo/client";
var __TripsUIToastUILinkActionFragment = gql2(_templateObject1());
var __TripsUIToastFragment = gql2(_templateObject2(), __TripsUIToastUILinkActionFragment);
// src/components/providers/external-items-operations-provider/operations/save-external-items-to-trip/mutation/save-external-items-to-trip-mutation.ts
var __SaveExternalItemsToTripMutation = gql3(_templateObject3(), __TripsUIToastFragment);
// src/components/providers/external-items-operations-provider/operations/save-external-items-to-trip/save-external-items-to-trip.ts
var saveExternalItemsToTrip = registerOperation({
    operationName: "saveExternalItemsToTrip"
});
// src/components/providers/external-items-operations-provider/external-items-operations-provider.tsx
var ExternalItemsOperationsProvider = function(param) {
    var children = param.children;
    var _useMutation = _sliced_to_array(useMutation(__ConnectExternalMailboxMutation), 1), connectExternalMailboxMutation = _useMutation[0];
    var _useMutation1 = _sliced_to_array(useMutation(__SaveExternalItemsToTripMutation), 1), saveExternalItemsToTripMutation = _useMutation1[0];
    var _React2_useState = _sliced_to_array(React2.useState(getDefaultOperationsState(Object.keys(defaultExternalItemsOperationsContext))), 2), operationState = _React2_useState[0], updateOperationState = _React2_useState[1];
    var value = React2.useMemo(function() {
        return {
            connectExternalMailbox: function(variables) {
                return connectExternalMailbox(connectExternalMailboxMutation, updateOperationState, variables);
            },
            saveExternalItemsToTrip: function(variables) {
                return saveExternalItemsToTrip(saveExternalItemsToTripMutation, updateOperationState, variables);
            },
            state: operationState
        };
    }, [
        operationState,
        connectExternalMailboxMutation
    ]);
    return /* @__PURE__ */ React2.createElement(ExternalItemsOperationsContext.Provider, {
        value: value
    }, children);
};
// src/components/providers/external-items-operations-provider/hooks/use-external-items-operations.ts
import React3 from "react";
function useExternalItemsOperations() {
    var _React3_useContext = React3.useContext(ExternalItemsOperationsContext), connectExternalMailbox2 = _React3_useContext.connectExternalMailbox, saveExternalItemsToTrip2 = _React3_useContext.saveExternalItemsToTrip, rest = _object_without_properties(_React3_useContext, [
        "connectExternalMailbox",
        "saveExternalItemsToTrip"
    ]);
    return _object_spread({
        connectExternalMailbox: React3.useCallback(connectExternalMailbox2, []),
        saveExternalItemsToTrip: React3.useCallback(saveExternalItemsToTrip2, [])
    }, rest);
}
// src/components/providers/signal-provider/signal-provider.tsx
import React4 from "react";
var SignalContext = React4.createContext(void 0);
var SignalProvider = function(param) {
    var children = param.children;
    var _React4_useState = _sliced_to_array(React4.useState([]), 2), subscribers = _React4_useState[0], setSubscribers = _React4_useState[1];
    var signalsRegistry = React4.useMemo(function() {
        return [];
    }, []);
    var registerSignal = React4.useCallback(function(signal) {
        if (!signal) {
            return {
                subscribe: null
            };
        }
        if (!signalsRegistry.find(function(signalInRegistry) {
            return Object.is(signalInRegistry, signal);
        })) {
            signalsRegistry.push(signal);
        }
        if (signal.reference) {
            var _subscribers_find;
            return {
                subscribe: (_subscribers_find = subscribers.find(function(s) {
                    return s.result.reference === signal.reference;
                })) !== null && _subscribers_find !== void 0 ? _subscribers_find : null
            };
        }
        var _subscribers_find1;
        return {
            subscribe: (_subscribers_find1 = subscribers.find(function(s) {
                return s.result.type === signal.type;
            })) !== null && _subscribers_find1 !== void 0 ? _subscribers_find1 : null
        };
    }, [
        signalsRegistry,
        subscribers
    ]);
    var onSignalEmit = React4.useCallback(function(signal, callback) {
        var subscribe = registerSignal(signal).subscribe;
        if (subscribe && signal) {
            if (signal.reference && subscribe.result.reference && signal.reference === subscribe.result.reference) {
                callback(subscribe);
            }
            if (!signal.reference && signal.type === subscribe.result.type) {
                callback(subscribe);
            }
        }
    }, [
        registerSignal
    ]);
    var emitSignals = React4.useCallback(function(signals) {
        var typesInRegistry = signalsRegistry.map(function(signal) {
            return signal.type;
        });
        var result = signals.filter(function(emitSignal) {
            return typesInRegistry.includes(emitSignal.signal.type);
        }).map(function(emitSignalInRegistry) {
            var _emitSignalInRegistry_signal_reference;
            return {
                result: {
                    type: emitSignalInRegistry.signal.type,
                    reference: (_emitSignalInRegistry_signal_reference = emitSignalInRegistry.signal.reference) !== null && _emitSignalInRegistry_signal_reference !== void 0 ? _emitSignalInRegistry_signal_reference : void 0,
                    values: emitSignalInRegistry.values
                }
            };
        });
        setSubscribers(result);
    }, [
        signalsRegistry
    ]);
    var context = React4.useMemo(function() {
        return {
            onSignalEmit: onSignalEmit,
            emitSignals: emitSignals
        };
    }, [
        onSignalEmit,
        emitSignals
    ]);
    return /* @__PURE__ */ React4.createElement(SignalContext.Provider, {
        value: context
    }, children);
};
// src/components/providers/signal-provider/use-signals.ts
import React5 from "react";
function useSignals() {
    var signalContext = React5.useContext(SignalContext);
    if (signalContext === void 0) {
        throw new Error("No Trips SignalProvider found in React tree");
    }
    return signalContext;
}
// src/components/providers/signal-provider/use-emit-signals-handler.ts
import { useProvidedState } from "@shared-ui/provided-state-context";
var useEmitSignalsHandler = function(emitSignalValues) {
    var emitSignals = useSignals().emitSignals;
    var _useProvidedState = _sliced_to_array(useProvidedState(), 1), state = _useProvidedState[0];
    return {
        emit: function() {
            var emitValues = emitSignalValues === null || emitSignalValues === void 0 ? void 0 : emitSignalValues.map(function(signal) {
                var values = signal.values.map(function(value) {
                    switch(value.value.__typename){
                        case "TripsSignalFieldIdValue":
                            {
                                var fieldIdValue = value.value;
                                var inputsValue = state.validatedInputs.inputFields.find(function(inputField) {
                                    return inputField.inputId === fieldIdValue.id;
                                });
                                return {
                                    __typename: value.__typename,
                                    key: value.key,
                                    value: inputsValue.inputValue
                                };
                            }
                        case "TripsSignalFieldIdExistingValues":
                            {
                                var fieldIdExistingValues = value.value;
                                var inputValues = fieldIdExistingValues.ids.map(function(id) {
                                    return state.validatedInputs.inputFields.find(function(inputField) {
                                        return inputField.inputId === id;
                                    });
                                }).map(function(inputField) {
                                    return inputField.inputValue;
                                });
                                var _fieldIdExistingValues_prefixes;
                                var combinedValues = _to_consumable_array((_fieldIdExistingValues_prefixes = fieldIdExistingValues.prefixes) !== null && _fieldIdExistingValues_prefixes !== void 0 ? _fieldIdExistingValues_prefixes : []).concat(_to_consumable_array(inputValues));
                                return {
                                    __typename: value.__typename,
                                    key: value.key,
                                    value: combinedValues
                                };
                            }
                        default:
                            return {
                                __typename: value.__typename,
                                key: value.key,
                                value: null
                            };
                    }
                });
                return {
                    __typename: signal.__typename,
                    signal: signal.signal,
                    values: values
                };
            });
            if (emitValues) {
                emitSignals(emitValues);
            }
        }
    };
};
// src/components/providers/trip-operations-provider/trip-operations-provider.tsx
import React7 from "react";
import { useMutation as useMutation2 } from "@apollo/client";
// src/components/providers/trip-operations-provider/context/trip-operations-context.ts
import React6 from "react";
// src/components/providers/trip-operations-provider/context/get-default-operation.ts
function getDefaultOperation2(operationName) {
    return function() {
        return Promise.resolve({
            success: false,
            failureReason: "No TripOperationsProvider found in tree found while calling ".concat(operationName),
            failure: {
                type: "NO_PROVIDER" /* NO_PROVIDER */ 
            }
        });
    };
}
// src/components/providers/trip-operations-provider/context/trip-operations-context.ts
var defaultTripOperationsContext = {
    createTripItineraryTemplate: getDefaultOperation2("createTripItineraryTemplate"),
    createTrip: getDefaultOperation2("createTrip"),
    deleteTrip: getDefaultOperation2("deleteTrip"),
    editTrip: getDefaultOperation2("editTrip"),
    updateTripItemTrip: getDefaultOperation2("updateTripItemTrip"),
    sendTripInvite: getDefaultOperation2("sendTripInvite")
};
var TripOperationsContext = React6.createContext(_object_spread_props(_object_spread({}, defaultTripOperationsContext), {
    state: getDefaultOperationsState(Object.keys(defaultTripOperationsContext))
}));
// src/components/providers/trip-operations-provider/operations/create-trip/create-trip.ts
var createTrip = registerOperation({
    operationName: "createTrip"
});
// src/components/providers/trip-operations-provider/operations/create-trip/mutation/create-trip-mutation.ts
import { gql as gql4 } from "@apollo/client";
// src/__generated__/types.ts
var AlterMode = /* @__PURE__ */ function(AlterMode2) {
    AlterMode2["DEBUG"] = "DEBUG";
    AlterMode2["NONE"] = "NONE";
    AlterMode2["PREVIEW"] = "PREVIEW";
    AlterMode2["RELEASED"] = "RELEASED";
    return AlterMode2;
}(AlterMode || {});
var AspectRatio = /* @__PURE__ */ function(AspectRatio2) {
    AspectRatio2["FOUR_ONE"] = "FOUR_ONE";
    AspectRatio2["FOUR_THREE"] = "FOUR_THREE";
    AspectRatio2["ONE_ONE"] = "ONE_ONE";
    AspectRatio2["SIXTEEN_NINE"] = "SIXTEEN_NINE";
    AspectRatio2["THREE_FOUR"] = "THREE_FOUR";
    AspectRatio2["THREE_TWO"] = "THREE_TWO";
    AspectRatio2["TWENTY_ONE_NINE"] = "TWENTY_ONE_NINE";
    return AspectRatio2;
}(AspectRatio || {});
var AuthenticationState = /* @__PURE__ */ function(AuthenticationState2) {
    AuthenticationState2["ANONYMOUS"] = "ANONYMOUS";
    AuthenticationState2["AUTHENTICATED"] = "AUTHENTICATED";
    AuthenticationState2["IDENTIFIED"] = "IDENTIFIED";
    return AuthenticationState2;
}(AuthenticationState || {});
var DeviceType = /* @__PURE__ */ function(DeviceType2) {
    DeviceType2["APP_PHONE"] = "APP_PHONE";
    DeviceType2["APP_TABLET"] = "APP_TABLET";
    DeviceType2["CHAT_APP"] = "CHAT_APP";
    DeviceType2["DESKTOP"] = "DESKTOP";
    DeviceType2["MOBILE_PHONE"] = "MOBILE_PHONE";
    DeviceType2["MOBILE_TABLET"] = "MOBILE_TABLET";
    DeviceType2["VOICE_APP"] = "VOICE_APP";
    return DeviceType2;
}(DeviceType || {});
var EGReferrerEventType = /* @__PURE__ */ function(EGReferrerEventType2) {
    EGReferrerEventType2["CLICK"] = "CLICK";
    EGReferrerEventType2["IMPRESSION"] = "IMPRESSION";
    return EGReferrerEventType2;
}(EGReferrerEventType || {});
var IconSize = /* @__PURE__ */ function(IconSize2) {
    IconSize2["EXTRA_SMALL"] = "EXTRA_SMALL";
    IconSize2["LARGE"] = "LARGE";
    IconSize2["MEDIUM"] = "MEDIUM";
    IconSize2["MEDIUM_LARGE"] = "MEDIUM_LARGE";
    IconSize2["SMALL"] = "SMALL";
    IconSize2["XLARGE"] = "XLARGE";
    return IconSize2;
}(IconSize || {});
var IconSpotLight = /* @__PURE__ */ function(IconSpotLight2) {
    IconSpotLight2["INFO"] = "INFO";
    IconSpotLight2["POSITIVE"] = "POSITIVE";
    IconSpotLight2["STANDARD"] = "STANDARD";
    IconSpotLight2["WARNING"] = "WARNING";
    return IconSpotLight2;
}(IconSpotLight || {});
var IconTheme = /* @__PURE__ */ function(IconTheme2) {
    IconTheme2["default"] = "default";
    IconTheme2["emphasis"] = "emphasis";
    IconTheme2["inverse"] = "inverse";
    IconTheme2["negative"] = "negative";
    IconTheme2["positive"] = "positive";
    return IconTheme2;
}(IconTheme || {});
var PrivacyTrackingState = /* @__PURE__ */ function(PrivacyTrackingState2) {
    PrivacyTrackingState2["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
    PrivacyTrackingState2["CAN_TRACK"] = "CAN_TRACK";
    return PrivacyTrackingState2;
}(PrivacyTrackingState || {});
var TripsSignalPairKey = /* @__PURE__ */ function(TripsSignalPairKey2) {
    TripsSignalPairKey2["PRIMARY"] = "PRIMARY";
    TripsSignalPairKey2["SECONDARY"] = "SECONDARY";
    TripsSignalPairKey2["STATUS"] = "STATUS";
    return TripsSignalPairKey2;
}(TripsSignalPairKey || {});
var TripsSignalType = /* @__PURE__ */ function(TripsSignalType2) {
    TripsSignalType2["REMOVE"] = "REMOVE";
    TripsSignalType2["UPDATE"] = "UPDATE";
    return TripsSignalType2;
}(TripsSignalType || {});
var TripsUIResponseStatus = /* @__PURE__ */ function(TripsUIResponseStatus2) {
    TripsUIResponseStatus2["FAIL"] = "FAIL";
    TripsUIResponseStatus2["SUCCESS"] = "SUCCESS";
    return TripsUIResponseStatus2;
}(TripsUIResponseStatus || {});
var UILinkTarget = /* @__PURE__ */ function(UILinkTarget2) {
    UILinkTarget2["EXTERNAL"] = "EXTERNAL";
    UILinkTarget2["INTERNAL"] = "INTERNAL";
    return UILinkTarget2;
}(UILinkTarget || {});
// src/components/providers/trip-operations-provider/operations/create-trip/mutation/create-trip-mutation.ts
var __CreateTripMutation = gql4(_templateObject4(), __TripsUIToastFragment);
// src/components/providers/trip-operations-provider/operations/delete-trip/delete-trip.ts
var deleteTrip = registerOperation({
    operationName: "deleteTrip"
});
// src/components/providers/trip-operations-provider/operations/delete-trip/mutation/delete-trip-mutation.ts
import { gql as gql5 } from "@apollo/client";
var __DeleteTripMutation = gql5(_templateObject5(), __TripsUIToastFragment);
// src/components/providers/trip-operations-provider/operations/edit-trip/edit-trip.ts
var editTrip = registerOperation({
    operationName: "editTrip"
});
// src/components/providers/trip-operations-provider/operations/edit-trip/mutation/edit-trip-mutation.ts
import { gql as gql6 } from "@apollo/client";
var __EditTripMutation = gql6(_templateObject6(), __TripsUIToastFragment);
// src/components/providers/trip-operations-provider/operations/update-trip-item-trip/mutation/update-trip-item-trip-mutation.ts
import { gql as gql7 } from "@apollo/client";
var __UpdateTripItemTripMutation = gql7(_templateObject7(), __TripsUIToastFragment);
// src/components/providers/trip-operations-provider/operations/update-trip-item-trip/update-trip-item-trip.ts
var updateTripItemTrip = registerOperation({
    operationName: "updateTripItemTrip"
});
// src/components/providers/trip-operations-provider/operations/send-trip-invite/send-trip-invite.ts
var sendTripInvite = registerOperation({
    operationName: "sendTripInvite"
});
// src/components/providers/trip-operations-provider/operations/send-trip-invite/mutation/send-trip-invite-mutation.ts
import { gql as gql8 } from "@apollo/client";
var __SendTripInviteTripMutation = gql8(_templateObject8(), __TripsUIToastFragment);
// src/components/providers/trip-operations-provider/operations/create-itinerary-template/create-itinerary-template.ts
var createTripItineraryTemplate = registerOperation({
    operationName: "createTripItineraryTemplate"
});
// src/components/providers/trip-operations-provider/operations/create-itinerary-template/mutation/create-trip-itinerary-template-mutation.ts
import { gql as gql9 } from "@apollo/client";
var __CreateTripItineraryTemplateMutation = gql9(_templateObject9());
// src/components/providers/trip-operations-provider/trip-operations-provider.tsx
var TripOperationsProvider = function(param) {
    var children = param.children;
    var _useMutation2 = _sliced_to_array(useMutation2(__CreateTripItineraryTemplateMutation), 1), createTripItineraryTemplateMutation = _useMutation2[0];
    var _useMutation21 = _sliced_to_array(useMutation2(__CreateTripMutation), 1), createTripMutation = _useMutation21[0];
    var _useMutation22 = _sliced_to_array(useMutation2(__DeleteTripMutation), 1), deleteTripMutation = _useMutation22[0];
    var _useMutation23 = _sliced_to_array(useMutation2(__EditTripMutation), 1), editTripMutation = _useMutation23[0];
    var _useMutation24 = _sliced_to_array(useMutation2(__SendTripInviteTripMutation), 1), sendTripInviteMutation = _useMutation24[0];
    var _useMutation25 = _sliced_to_array(useMutation2(__UpdateTripItemTripMutation), 1), updateTripItemTripMutation = _useMutation25[0];
    var _React7_useState = _sliced_to_array(React7.useState(getDefaultOperationsState(Object.keys(defaultTripOperationsContext))), 2), operationState = _React7_useState[0], updateOperationState = _React7_useState[1];
    var value = React7.useMemo(function() {
        return {
            createTripItineraryTemplate: function(variables) {
                return createTripItineraryTemplate(createTripItineraryTemplateMutation, updateOperationState, variables);
            },
            createTrip: function(variables) {
                return createTrip(createTripMutation, updateOperationState, variables);
            },
            deleteTrip: function(variables) {
                return deleteTrip(deleteTripMutation, updateOperationState, variables);
            },
            editTrip: function(variables) {
                return editTrip(editTripMutation, updateOperationState, variables);
            },
            updateTripItemTrip: function(variables) {
                return updateTripItemTrip(updateTripItemTripMutation, updateOperationState, variables);
            },
            sendTripInvite: function(variables) {
                return sendTripInvite(sendTripInviteMutation, updateOperationState, variables);
            },
            state: operationState
        };
    }, [
        operationState,
        createTripItineraryTemplateMutation,
        createTripMutation,
        deleteTripMutation,
        editTripMutation,
        updateTripItemTripMutation,
        sendTripInviteMutation
    ]);
    return /* @__PURE__ */ React7.createElement(TripOperationsContext.Provider, {
        value: value
    }, children);
};
// src/components/providers/trip-operations-provider/hooks/use-trip-operations.ts
import React8 from "react";
function useTripOperations() {
    var _React8_useContext = React8.useContext(TripOperationsContext), createTripItineraryTemplate2 = _React8_useContext.createTripItineraryTemplate, createTrip2 = _React8_useContext.createTrip, deleteTrip2 = _React8_useContext.deleteTrip, editTrip2 = _React8_useContext.editTrip, sendTripInvite2 = _React8_useContext.sendTripInvite, updateTripItemTrip2 = _React8_useContext.updateTripItemTrip, rest = _object_without_properties(_React8_useContext, [
        "createTripItineraryTemplate",
        "createTrip",
        "deleteTrip",
        "editTrip",
        "sendTripInvite",
        "updateTripItemTrip"
    ]);
    return _object_spread({
        createTripItineraryTemplate: React8.useCallback(createTripItineraryTemplate2, []),
        createTrip: React8.useCallback(createTrip2, []),
        deleteTrip: React8.useCallback(deleteTrip2, []),
        editTrip: React8.useCallback(editTrip2, []),
        updateTripItemTrip: React8.useCallback(updateTripItemTrip2, []),
        sendTripInvite: React8.useCallback(sendTripInvite2, [])
    }, rest);
}
// src/components/providers/trip-item-operations-provider/trip-item-operations-provider.tsx
import React10 from "react";
import { useMutation as useMutation3 } from "@apollo/client";
// src/components/providers/trip-item-operations-provider/context/trip-item-operations-context.ts
import React9 from "react";
// src/components/providers/trip-item-operations-provider/context/get-default-operation.ts
function getDefaultOperation3(operationName) {
    return function() {
        return Promise.resolve({
            success: false,
            failureReason: "No TripItemOperationsProvider found in tree found while calling ".concat(operationName),
            failure: {
                type: "NO_PROVIDER" /* NO_PROVIDER */ 
            }
        });
    };
}
// src/components/providers/trip-item-operations-provider/context/trip-item-operations-context.ts
var defaultTripItemOperationsContext = {
    removeTripItem: getDefaultOperation3("removeTripItem"),
    saveTripItems: getDefaultOperation3("saveTripItems"),
    updateTripItemDates: getDefaultOperation3("updateTripItemDates"),
    updateTripItemVote: getDefaultOperation3("updateTripItemVote"),
    saveTripItemComment: getDefaultOperation3("saveTripItemComment")
};
var TripItemOperationsContext = React9.createContext(_object_spread_props(_object_spread({}, defaultTripItemOperationsContext), {
    state: getDefaultOperationsState(Object.keys(defaultTripItemOperationsContext))
}));
// src/components/providers/trip-item-operations-provider/operations/remove-trip-item/remove-trip-item.ts
var removeTripItem = registerOperation({
    operationName: "removeTripItem"
});
// src/components/providers/trip-item-operations-provider/operations/remove-trip-item/mutation/remove-trip-item-mutation.ts
import { gql as gql10 } from "@apollo/client";
var __RemoveTripItemMutation = gql10(_templateObject10(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/save-trip-items/save-trip-items.ts
var saveTripItems = registerOperation({
    operationName: "saveTripItems"
});
// src/components/providers/trip-item-operations-provider/operations/save-trip-items/mutation/save-trip-items-mutation.ts
import { gql as gql11 } from "@apollo/client";
var __SaveTripItemsMutation = gql11(_templateObject11(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/update-trip-item-dates/mutation/update-trip-item-dates-mutation.ts
import { gql as gql12 } from "@apollo/client";
var __UpdateTripItemDatesMutation = gql12(_templateObject12(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/update-trip-item-dates/update-trip-item-dates.ts
var updateTripItemDates = registerOperation({
    operationName: "updateTripItemDates"
});
// src/components/providers/trip-item-operations-provider/operations/update-trip-item-vote/mutation/update-trip-item-vote-mutation.ts
import { gql as gql13 } from "@apollo/client";
var __UpdateTripItemVoteMutation = gql13(_templateObject13(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/update-trip-item-vote/update-trip-item-vote.ts
var updateTripItemVote = registerOperation({
    operationName: "updateTripItemVote"
});
// src/components/providers/trip-item-operations-provider/operations/save-trip-item-comment/mutation/save-trip-item-comment-mutation.ts
import { gql as gql14 } from "@apollo/client";
var __SaveTripItemCommentMutation = gql14(_templateObject14(), __TripsUIToastFragment);
// src/components/providers/trip-item-operations-provider/operations/save-trip-item-comment/save-trip-item-comment.ts
var saveTripItemComment = registerOperation({
    operationName: "saveTripItemComment"
});
// src/components/providers/trip-item-operations-provider/trip-item-operations-provider.tsx
var TripItemOperationsProvider = function(param) {
    var children = param.children;
    var _useMutation3 = _sliced_to_array(useMutation3(__RemoveTripItemMutation), 1), removeTripItemMutation = _useMutation3[0];
    var _useMutation31 = _sliced_to_array(useMutation3(__SaveTripItemsMutation), 1), saveTripItemsMutation = _useMutation31[0];
    var _useMutation32 = _sliced_to_array(useMutation3(__UpdateTripItemDatesMutation), 1), updateTripItemDatesMutation = _useMutation32[0];
    var _useMutation33 = _sliced_to_array(useMutation3(__UpdateTripItemVoteMutation), 1), updateTripItemVoteMutation = _useMutation33[0];
    var _useMutation34 = _sliced_to_array(useMutation3(__SaveTripItemCommentMutation), 1), saveTripItemCommentMutation = _useMutation34[0];
    var _React10_useState = _sliced_to_array(React10.useState(getDefaultOperationsState(Object.keys(defaultTripItemOperationsContext))), 2), operationState = _React10_useState[0], updateOperationState = _React10_useState[1];
    var value = React10.useMemo(function() {
        return {
            removeTripItem: function(variables) {
                return removeTripItem(removeTripItemMutation, updateOperationState, variables);
            },
            saveTripItems: function(variables) {
                return saveTripItems(saveTripItemsMutation, updateOperationState, variables);
            },
            updateTripItemDates: function(variables) {
                return updateTripItemDates(updateTripItemDatesMutation, updateOperationState, variables);
            },
            updateTripItemVote: function(variables) {
                return updateTripItemVote(updateTripItemVoteMutation, updateOperationState, variables);
            },
            saveTripItemComment: function(variables) {
                return saveTripItemComment(saveTripItemCommentMutation, updateOperationState, variables);
            },
            state: operationState
        };
    }, [
        operationState,
        removeTripItemMutation,
        saveTripItemsMutation,
        updateTripItemDatesMutation,
        updateTripItemVoteMutation,
        saveTripItemComment,
        saveTripItemCommentMutation
    ]);
    return /* @__PURE__ */ React10.createElement(TripItemOperationsContext.Provider, {
        value: value
    }, children);
};
// src/components/providers/trip-item-operations-provider/hooks/use-trip-item-operations.ts
import React11 from "react";
function useTripItemOperations() {
    var _React11_useContext = React11.useContext(TripItemOperationsContext), removeTripItem2 = _React11_useContext.removeTripItem, saveTripItems2 = _React11_useContext.saveTripItems, updateTripItemDates2 = _React11_useContext.updateTripItemDates, updateTripItemVote2 = _React11_useContext.updateTripItemVote, saveTripItemComment2 = _React11_useContext.saveTripItemComment, rest = _object_without_properties(_React11_useContext, [
        "removeTripItem",
        "saveTripItems",
        "updateTripItemDates",
        "updateTripItemVote",
        "saveTripItemComment"
    ]);
    return _object_spread({
        removeTripItem: React11.useCallback(removeTripItem2, []),
        saveTripItems: React11.useCallback(saveTripItems2, []),
        updateTripItemDates: React11.useCallback(updateTripItemDates2, []),
        updateTripItemVote: React11.useCallback(updateTripItemVote2, []),
        saveTripItemComment: React11.useCallback(saveTripItemComment2, [])
    }, rest);
}
// src/components/providers/template-context-provider/template-context-provider.tsx
import React12 from "react";
var TemplateContext = React12.createContext(void 0);
var TemplateContextProvider = function(param) {
    var children = param.children, signals = param.signals;
    var memoizedTemplateContextSignals = React12.useMemo(function() {
        return {
            signals: signals
        };
    }, [
        signals
    ]);
    return /* @__PURE__ */ React12.createElement(TemplateContext.Provider, {
        value: memoizedTemplateContextSignals
    }, children);
};
function useTemplateContext() {
    return React12.useContext(TemplateContext);
}
// src/components/providers/toast-provider/toast-provider.tsx
import React15 from "react";
// src/components/providers/toast-provider/trips-ui-fallback-toast.tsx
import React13 from "react";
import { UitkToast } from "uitk-react-toast";
var getTripsUIFallbackToast = function(input, setTripsFallbackToastData) {
    var TripsUIFallbackToast = function() {
        var onDismiss = React13.useCallback(function() {
            var _input_toastProps;
            if ((_input_toastProps = input.toastProps) === null || _input_toastProps === void 0 ? void 0 : _input_toastProps.onDismiss) {
                input.toastProps.onDismiss();
            }
            setTripsFallbackToastData(void 0);
        }, [
            input.toastProps
        ]);
        return /* @__PURE__ */ React13.createElement(UitkToast, _object_spread_props(_object_spread({}, input.toastProps), {
            show: true,
            onDismiss: onDismiss
        }), input.data);
    };
    TripsUIFallbackToast.displayName = "TripsUIFallbackToast";
    return TripsUIFallbackToast;
};
// src/components/providers/toast-provider/trips-ui-toast.tsx
import React14 from "react";
import { ITrackType, useClickstreamAnalytics, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkToast as UitkToast2 } from "uitk-react-toast";
var getTripsUIToast = function(input, setTripsToastData) {
    var TripsUIToast = function() {
        var clickTrack = useClickTracker();
        var track = useClickstreamAnalytics().track;
        React14.useEffect(function() {
            var _input_data_analytics_linkName;
            track(ITrackType.EVENT, {
                data: {
                    schemaName: "referrer",
                    messageContent: {
                        referrerId: input.data.analytics.referrerId,
                        linkName: (_input_data_analytics_linkName = input.data.analytics.linkName) !== null && _input_data_analytics_linkName !== void 0 ? _input_data_analytics_linkName : input.data.analytics.referrerId,
                        eventType: "impression"
                    }
                }
            });
        }, [
            input.data.analytics
        ]);
        var onDismiss = React14.useCallback(function() {
            var _input_toastProps;
            if ((_input_toastProps = input.toastProps) === null || _input_toastProps === void 0 ? void 0 : _input_toastProps.onDismiss) {
                input.toastProps.onDismiss();
            }
            setTripsToastData(void 0);
        }, [
            input.toastProps
        ]);
        var toastAction = React14.useCallback(function() {
            if (input.data.action) {
                window.location.href = input.data.action.resource.value;
                if (input.data.action.analytics) {
                    clickTrack(input.data.action.analytics.referrerId, input.data.action.analytics.linkName);
                }
            }
        }, [
            input.data.action
        ]);
        var _input_data_actionText;
        return /* @__PURE__ */ React14.createElement(UitkToast2, _object_spread_props(_object_spread({}, input.toastProps), {
            show: true,
            actionCallback: toastAction,
            actionText: (_input_data_actionText = input.data.actionText) !== null && _input_data_actionText !== void 0 ? _input_data_actionText : void 0,
            onDismiss: onDismiss
        }), input.data.text);
    };
    TripsUIToast.displayName = "TripsUIToast";
    return TripsUIToast;
};
// src/components/providers/toast-provider/toast-provider.tsx
var defaultTripsToastContext = {
    setTripsToastData: function() {
        return void 0;
    },
    setTripsFallbackToastData: function() {
        return void 0;
    }
};
var TripsToastContext = React15.createContext(defaultTripsToastContext);
var TripsToastProvider = function(param) {
    var children = param.children;
    var _React15_useState = _sliced_to_array(React15.useState(void 0), 2), tripsUIToastData = _React15_useState[0], setTripsUIToastData = _React15_useState[1];
    var _React15_useState1 = _sliced_to_array(React15.useState(void 0), 2), tripsUIFallbackToastData = _React15_useState1[0], setTripsUIFallbackToastData = _React15_useState1[1];
    var memoizedTripsToastContext = React15.useMemo(function() {
        return {
            setTripsToastData: setTripsUIToastData,
            setTripsFallbackToastData: setTripsUIFallbackToastData
        };
    }, [
        setTripsUIToastData,
        setTripsUIFallbackToastData
    ]);
    var TripsUIToast = React15.useMemo(function() {
        return tripsUIToastData ? getTripsUIToast(tripsUIToastData, setTripsUIToastData) : void 0;
    }, [
        tripsUIToastData,
        setTripsUIToastData
    ]);
    var TripsUIFallbackToast = React15.useMemo(function() {
        return tripsUIFallbackToastData ? getTripsUIFallbackToast(tripsUIFallbackToastData, setTripsUIFallbackToastData) : void 0;
    }, [
        tripsUIFallbackToastData,
        setTripsUIFallbackToastData
    ]);
    return /* @__PURE__ */ React15.createElement(TripsToastContext.Provider, {
        value: memoizedTripsToastContext
    }, children, TripsUIToast && /* @__PURE__ */ React15.createElement(TripsUIToast, null), TripsUIFallbackToast && /* @__PURE__ */ React15.createElement(TripsUIFallbackToast, null));
};
var useTripsToast = function() {
    return React15.useContext(TripsToastContext);
};
export { AlterMode, AspectRatio, AuthenticationState, DeviceType, EGReferrerEventType, ExternalItemsOperationsProvider, IconSize, IconSpotLight, IconTheme, OperationFailureType, PrivacyTrackingState, SignalProvider, TemplateContextProvider, TripItemOperationsProvider, TripOperationsProvider, TripsSignalPairKey, TripsSignalType, TripsToastProvider, TripsUIResponseStatus, UILinkTarget, __ConnectExternalMailboxMutation, __CreateTripItineraryTemplateMutation, __CreateTripMutation, __DeleteTripMutation, __EditTripMutation, __RemoveTripItemMutation, __SaveExternalItemsToTripMutation, __SaveTripItemCommentMutation, __SaveTripItemsMutation, __SendTripInviteTripMutation, __TripsUIToastFragment, __UpdateTripItemDatesMutation, __UpdateTripItemTripMutation, __UpdateTripItemVoteMutation, connectExternalMailbox, createTrip, createTripItineraryTemplate, deleteTrip, editTrip, removeTripItem, saveExternalItemsToTrip, saveTripItemComment, saveTripItems, sendTripInvite, updateTripItemDates, updateTripItemTrip, updateTripItemVote, useEmitSignalsHandler, useExternalItemsOperations, useSignals, useTemplateContext, useTripItemOperations, useTripOperations, useTripsToast };
//# sourceMappingURL=index.js.map